<template>
    <div class="p-5 h-full flex justify-center">
        <div class="w-full" :class="{ '!w-[1280px]': form }">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
    // Props
    defineProps({
        form: Boolean
    });
</script>